import { DialogKey } from '@sorare/core/src/components/navigation/WithDialogs';
import { useCloseDialog } from '@sorare/core/src/hooks/navigation/useCloseDialog';
import { useDialogParam } from '@sorare/core/src/hooks/navigation/useDialogParam';

import { So5LeaderboardContenderDialog } from '#src/components/lineup/So5LeaderboardContenderDialog/index.tsx';

export const So5LeaderboardContenderDialogFromParams = () => {
  const contender = useDialogParam(DialogKey.contender);
  const closeDialog = useCloseDialog();

  if (!contender) {
    return null;
  }

  return (
    <So5LeaderboardContenderDialog
      open
      onClose={() => closeDialog(DialogKey.contender)}
      so5LeaderboardContenderSlug={contender}
    />
  );
};
